(function() {
  // disable right click
  document.addEventListener('contextmenu', event => event.preventDefault());

  document.onkeydown = function (e) {

      // disable F12 key
      if(e.keyCode == 123) {
          return false;
      }

      // disable I key
      if(e.ctrlKey && e.shiftKey && e.keyCode == 73){
          return false;
      }

      // disable J key
      if(e.ctrlKey && e.shiftKey && e.keyCode == 74) {
          return false;
      }

      // disable U key
      if(e.ctrlKey && e.keyCode == 85) {
          return false;
      }
  }
   var collectionTabs = function(){
    $('.featured-coll__tabs a').on('click',function(e){
      e.preventDefault();
      var id = $(this).attr('href'); 
      $('.featured-coll__tabs a').removeClass('activeTab--cell');
      $(this).addClass('activeTab--cell');
      $('.featured-coll__tabs-content > div').hide();
      $('.featured-coll__tabs-content > div'+id).show();
      $(".coll-swiper-tabs").each(function(){
      });
    })
  }; 
   var module2List = function() {
    $(document).on('click','.module2-list a', function(e){
      e.preventDefault();
      var id = $(this).attr('href');
      $('.module2-list a').removeClass('activeList');
      $(this).addClass('activeList');
      $('.module2-list-content > div').hide(); 
      $('.module2-list-content > div'+id).show();
    });
  }; 
  var collectionSwatch = function() {
    $(document).on('click', '.collection_swatches a.swatch', function(e) {
      e.preventDefault();
       $(this).parent().find('a.swatch').removeClass('selected-swatch');
       $(this).addClass('selected-swatch');
      var variantImg = $(this).data("image");
      var title = $(this).data('title');
      $(this).parents('.card-information').find('.product-variant_title').html(title);
        if($(this).data("image").indexOf("no-image") == -1) {  
          $(this).parents('.product-card-wrapper').find('.card__media .card-primary-image').attr('src', variantImg);
          $(this).parents('.product-card-wrapper').find('.card__media .card-primary-image').attr('srcset', variantImg);
        } 
    }); 
  };
  var featuredReviewsSlider = function() {
    $('.featured-reviews-slider').flickity({
      // options
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      autoPlay: true,
      autoPlay: 6000
    });
  };
   var featuredGallerySlider = function() {
    $('.featured-gallery-slider').flickity({
      // options 
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false
    });
  };
  var featuredCustomersSlider = function() {
    $('.featured-customers__wrap').flickity({
      // options 
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      fade: true
    });
  };
  var trustpiotReviewSlider = function() {
    $('.trustpiot_review_slider').flickity({
      // options 
      cellAlign: ' center',
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      groupCells: true
    });
  };
    var videoPlay = function() {
    $(document).on('click', '.videoPlay', function(e) {
      e.preventDefault();
      $(this).parent().addClass('active');
      if($(this).parent().find(".video_iframe_yt").length > 0){
        $(this).parent().find(".video_iframe_yt")[0].src += "&autoplay=1";
      }
      if($(this).parent().find("video").length > 0){
        $(this).parent().find(".ctm_video")[0].play();
      }
    });
    
    $(document).on('click', '.vid-play', function(e) {
      e.preventDefault();
       $(this).hide();
      $(this).parent().find('.vid-pause').css('display','block');
       $(this).parents('.videoWrapper').find("video").get(0).play();
    });
    $(document).on('click', '.vid-pause', function(e) {
      e.preventDefault();
      $(this).hide();
       $(this).parent().find('.vid-play').css('display','block');
       $(this).parents('.videoWrapper').find("video").get(0).pause();
    });
    
    $(document).on('click', '.vid-unmute', function(e) {
      e.preventDefault();
       $(this).hide();
      $(this).parent().find('.vid-mute').css('display','block');
       $(this).parents('.videoWrapper').find("video").prop('muted', false)
    });
    $(document).on('click', '.vid-mute', function(e) {
      e.preventDefault();
      $(this).hide();
       $(this).parent().find('.vid-unmute').css('display','block');
       $(this).parents('.videoWrapper').find("video").prop('muted', true)
    });
  };

  var cartDrawerAddons = function() {

    function carItemUpdate() {
        $.getJSON('/cart.json').then(cart => {
          fetch('cart?view=item').then(response => response.text())
          .then(text => {
              const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
              const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
              const totalPrice=sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
              $('#CartDrawer').html(cartFormInnerHTML)
              $('cart-drawer').removeClass('is-empty')
              $('cart-drawer-items').removeClass('is-empty')
            if($('#cart-icon-bubble .cart-count-bubble').length===0){
              const cartNumber=document.createElement('div')
              cartNumber.className='cart-count-bubble'
              cartNumber.innerHTML=`
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} items</span>
              `
              $('#cart-icon-bubble').append(cartNumber)
            }else{
               $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
            }
             $('#cart-icon-bubble')[0].click()
              $('#CartDrawer-Overlay').on('click',()=>{
                $('cart-drawer').removeClass('active')
                $('body').removeClass('overflow-hidden')
              })
          })
      });
    }
    
     $(document).on('click', '.cart__flyout-multiOpt_btn:not(.active)', function(e) {
       e.preventDefault();
       $(this).addClass('active');
       $(this).html("Add");
       $(this).parents('.cart__flyout-recommendations-item').find('.cart__flyout-option-dropdown').show();
     });
    $(document).on('click', '.cart__flyout-multiOpt_btn.active', function(e) {
       e.preventDefault();
        var id = $(this).closest('.cart__flyout-recommendations-item').find('.cart__flyout-option-dropdown select').val();
        var parent = $(this).closest('.cart__flyout-recommendations-item'); 
         $(this).html("Adding..");
        $.ajax({
          type:"post",
          dataType: "json",
          url: '/cart/add.js',
          data:{quantity:1,id:id},
          success: function(data){
            $(parent).find('.cart__flyout-multiOpt_btn.active').html("Added");
             setTimeout(function () {
               $(parent).find('.cart__flyout-multiOpt_btn.active').html("Add");
                carItemUpdate();
              }, 1500);
          }
        });
     });

      $(document).on('click', '.cart__flyout-singleOpt_btn', function(e) {
         e.preventDefault();
          var id = $(this).data('val');
          var parent = $(this).closest('.cart__flyout-recommendations-item'); 
          console.log(id);
           $(this).html("Adding..");
          $.ajax({
            type:"post",
            dataType: "json",
            url: '/cart/add.js',
            data:{quantity:1,id:id},
            success: function(data){
              $(parent).find('.cart__flyout-singleOpt_btn').html("Added");
               setTimeout(function () {
                 $(parent).find('.cart__flyout-singleOpt_btn').html("Add");
                  carItemUpdate();
                }, 1500);
            }
          });
       });
    
  };
  
  collectionTabs();
  module2List();
  collectionSwatch();
  featuredReviewsSlider();
  featuredGallerySlider();
  videoPlay();
  featuredCustomersSlider();
  cartDrawerAddons();
  trustpiotReviewSlider();

  Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options
  });
  
   $(document).on('shopify:section:load', function(event) {
     collectionTabs();
     module2List();
     collectionSwatch();
     featuredReviewsSlider();
     featuredGallerySlider();
     videoPlay();
     featuredCustomersSlider();
     cartDrawerAddons();
     trustpiotReviewSlider();
     
     Fancybox.bind('[data-fancybox="gallery"]', {
      // Your custom options
    });
  }); 
  
}());